import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function CategoryTile({ image, title, subtitle, to, testid, tall = false }) {
  return (
    <Link to={to} data-testid={testid}
          className={`cat-tile group relative overflow-hidden block ${tall ? "aspect-[3/4]" : "aspect-[4/3]"}`}>
      <img src={image} alt={title} loading="lazy" className="absolute inset-0 w-full h-full object-cover" />
      <div className="absolute inset-0 bg-gradient-to-t from-navy/75 via-navy/10 to-transparent" />
      <div className="absolute bottom-0 left-0 p-5 sm:p-6">
        {subtitle && <p className="text-ivory/80 text-xs mb-1">{subtitle}</p>}
        <h3 className="font-serif text-xl sm:text-2xl text-white">{title}</h3>
        <span className="inline-flex items-center gap-1.5 mt-2 text-gold text-sm font-medium tracking-wide">
          Разгледай
          <ArrowRight size={15} className="transition-transform group-hover:translate-x-1" />
        </span>
      </div>
    </Link>
  );
}
